import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <footer>
      <div className="footer-outer gray-300">
        <div className="footer-area">
          <div className="container">
            <div className="footer-wrapper">
              <div className="footer-watermark">
                {/* <!--<h1>Footer</h1>--> */}
              </div>
              <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-5 order-1">
                  <div className="footer-widget mt-0">
                    <h5 className="footer-widget-title">Quick Link</h5>
                    <div className="footer-links">
                      <ul className="link-list ps-0 mb-0">
                        <li><a href="https://vitiyagyanmela.icai.org" className="footer-link">Home</a></li>
                        <li><a href="https://vitiyagyanmela.icai.org/about" className="footer-link">About</a></li>
                        <li>
                          <a href="https://vitiyagyanmela.icai.org/registration" className="footer-link">Registration</a>
                        </li>
                        <li>
                          <a href="https://vitiyagyanmela.icai.org/event" className="footer-link">Events</a>
                        </li>

                        <li><a href="https://vitiyagyanmela.icai.org/stalls" className="footer-link">Knowledge Booth</a></li>
                        <li>
                          <a href="https://vitiyagyanmela.icai.org/knowledge-hub" className="footer-link">Knowledge Hub</a>
                        </li>
                        <li>
                          <a href="https://vitiyagyanmela.icai.org/contact" className="footer-link">Contact/Branch</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-7 order-lg-3 order-2">
                  <div className="footer-widget mt-0">
                    <h5 className="footer-widget-title">Important Link</h5>
                    <div className="footer-links">
                      <ul className="link-list ps-0 mb-0">
                        <li>
                          <a href="#" className="footer-link">Advertisement/Banner</a>
                        </li>
                        <li><a href="#" className="footer-link">Success Story</a></li>

                        <li>
                          <a href="https://vitiyagyanmela.icai.org/do-donot" className="footer-link">Do and Don't </a>
                        </li>
                        <li>
                          <a href="#" className="footer-link">FTL Reports</a>
                        </li>
                        <li>
                          <a href="https://vitiyagyanmela.icai.org/feedback" className="footer-link">Feedback</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-7 order-lg-3 order-1">
                  <div className="footer-widget">
                    <h5 className="footer-widget-title">Contact</h5>
                    <div className="footer-links">
                      <ul className="link-list ps-0 mb-0">
                        <li className="contact-box">
                          <div className="contact-icon">
                            <i className="bi bi-telephone-plus"></i>
                          </div>
                          <div className="contact-links">
                            <a href="tel:01130110510">+91-1130110510</a>
                            <a href="tel:+91-8800229830">+91-8800229830</a>
                          </div>
                        </li>
                        <li className="contact-box">
                          <div className="contact-icon">
                            <i className="bi bi-envelope-open"></i>
                          </div>
                          <div className="contact-links">
                            <a href="#"><span className="__cf_email__">ftl.nc@icai.in</span></a>
                            <a href="#"><span className="__cf_email__">ftl2@icai.in</span></a>
                          </div>
                        </li>
                        <li className="contact-box">
                          <div className="contact-icon">
                            <i className="bi bi-geo-alt"></i>
                          </div>
                          <div className="contact-links">
                            <a href="#">ICAI Bhawan, Indraprastha Marg, Post Box No. 7100
                              New Delhi - 110 002</a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-7 order-lg-3 order-2">
                  <div className="footer-widget d-flex flex-column justify-content-center">
                    <h5 className="footer-widget-title text-center">
                      QR Code for Registration
                    </h5>
                    <div className="d-flex justify-content-center">
                      <img width="140px" src="https://vitiyagyanmela.icai.org/frontend/assets/images/QR-code/qr-code.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-5">
                  <div className="footer-newslatter-wrapper text-center">
                    <h3>Subscribe Our Newsletter</h3>

                    <form className="newslatter-form" action="#" id="newslatter-form">
                      <div className="newslatter-input-group d-flex">
                        <input type="email" placeholder="Enter Your Email" />
                        <button type="submit">Subscribe</button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="footer-follow-us">
                    <div className="">
                      <h5>ICAI Socials</h5>
                      <ul className="footer-social-icon-ul mb-0 ps-0">
                        <li>
                          <a target="_blank" href="https://www.facebook.com/theicai">
                          {/* <i className="bi bi-facebook"></i> */}
                            <i className="fab fa-facebook-f"></i>
                            </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://www.youtube.com/icaiorgtube">
                            <i className="fab fa-youtube"></i>
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://www.linkedin.com/school/theicai/"><i className="fab fa-linkedin-in"></i>
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://www.instagram.com/icaiorg/"><i className="fab fa-instagram"></i></a>
                        </li>

                        <li>
                          <a className="" target="_blank" href="https://www.kooapp.com/profile/theicai/">
                            <img width="18px" src="https://vitiyagyanmela.icai.org/frontend/assets/images/social/kooapp.png" />
                          </a>
                        </li>

                        <li>
                          <a target="_blank" href="https://t.me/theicai"><i className="fab fa-telegram-plane"></i></a>
                        </li>
                        <li>
                          <a className="" target="_blank" href="https://www.threads.net/@icaiorg">
                            <img width="18px" src="https://vitiyagyanmela.icai.org/frontend/assets//images/social/threads.png" />
                          </a>
                        </li>

                        <li>
                          <a className="" target="_blank" href="https://twitter.com/theicai">
                            <img width="18px" src="https://vitiyagyanmela.icai.org/frontend/assets/images/social/twitter.png" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://icai.org/whatsapp"><i className="fab fa-whatsapp"></i></a>
                        </li>
                      </ul>
                    </div>
                    <div className="">
                      <h5 className="mt-3">FTL Social</h5>
                      <ul className="footer-social-icon-ul mb-0 ps-0">
                        <li>
                          <a className="" target="_blank" href="https://twitter.com/icaivittiyagyan">
                            <img width="18px" src="https://vitiyagyanmela.icai.org/frontend/assets/images/social/twitter.png" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                </div>
                <div className="col-lg-3">
                  <p style={{color: "#fff"}}><b>Note:</b> Download the branch QR code from the branch admin
                    dashboard.</p>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <div className="row align-items-center">
                <div className="col-lg-8 order-3 order-lg-1">
                  <div className="footer-copyright">
                    <p>
                      Copyright © 2024 FTL(ICAI) | All Rights Reserved. and Design by: <a href="https://savincommunication.com/">Savin Communication</a>
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 order-2 order-lg-3">
                  <ul className="d-flex footer-social-links justify-content-lg-end justify-content-center">
                    <li>
                      <a href="#">Privacy </a>
                    </li>
                    <li>
                      <a href="#">Policy </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
